import Campaigns from './Campaigns'
import { connect } from "react-redux";
import * as campaignActions from './../../../../actions/campaignAction';

const mapStateToProps = state => {
    return {
        campaignState: state.campaignReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListCampaigns: (filters) => dispatch(campaignActions.getListCampaigns(filters)),
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(Campaigns)